'use strict';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import filterTemplate from '../filters/asset-projects-filter.html';
import {getAssetProjectList} from '../reducers/state';
import {buildAssetProjectList, defaultFilterOptions, defaultSortOptions} from './assetProjectConfig';
import {ASSET_LIST_PREFIX} from './state';
import {FilterModalOptions} from '../../core-utilities/filters/FilterModalOptions';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {projectStates} from '../router-config';


const itemPath = 'asset-projects';

/** @type {ReduxList} */
export const reduxList = buildAssetProjectList({
  prefix: ASSET_LIST_PREFIX,
  getState: getAssetProjectList,
  listPath: parentId => `projects/${parentId}/assets`,
  listSyncPath: parentId => `projects/${parentId}/assets/${SYNC_PATH}`,
  deleteItemPath: itemId => `${itemPath}/${itemId}`,
}, {
  navStates: [projectStates.projectsAssetProjectsList],
});

export const filterModalOptions = new FilterModalOptions({
  filterTemplate,
  filterOptions: defaultFilterOptions,
  sortOptions: defaultSortOptions,
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, {
  autoInit: false,
  filterModalOptions,
});



// WEBPACK FOOTER //
// ./src/js/projects/redux/assetProjectList.js